import React from "react";
import Projects from "./Projects";
import EternalSeptember from "./EternalSeptember";
import TheForks from "./TheForks";

const components = {
  projects: <Projects></Projects>,
  eternalSept: <EternalSeptember></EternalSeptember>,
  theForks: <TheForks></TheForks>
};

// Added props: currentPage, setCurrentPage
function Portfolio({ currentPage, setCurrentPage }) {
    // NOTE: The state management is now external and passed in via props.
    // The handleNavigation function is no longer needed here as the buttons 
    // are in the FloatingHeader and will call setCurrentPage directly.

  const renderComponent = () => {
    return components[currentPage];
  };

  return (
    <div className="f-col center">
      {/* The navigation-buttons div has been removed from here */}
       {renderComponent()}
    </div>
  );
}

export default Portfolio;